webpackJsonp([117153192179967],{

/***/ 1085:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0015_now.jpg","type":"Spell","subtype":"Buff","cost":1,"ATK":null,"HP":null,"rules_text_1":"Give a unit or hero haste this turn.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Now!","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Purple","spec":"Present","bottom":"Magic","rulings":[],"keywords":["Haste"],"slug":"now"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"now","keywords":["Haste"],"imageRegex":"/now.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-now-36d7832bccabd8c6f9ec.js